import { Flex, Text } from 'pcln-design-system'
import { Notification } from 'pcln-icons'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

import {
  StyledBanner,
  StyledClose,
  StyledFlexLeft,
  StyledFlexRight,
} from './FlexDatesPriceChangeBanner.styles'

export const FlexDatesBanner = ({ diff, isVariant }) => {
  const [hide, setHide] = useState(false)

  const baseColor = diff < 0 ? 'secondary.light' : 'caution.light'
  const notificationColor = diff < 0 ? 'secondary.base' : 'text.base'
  const isValidDiff = diff !== 0 && diff
  const renderBanner = !hide && isValidDiff && isVariant

  /* istanbul ignore next */
  const handleClick = () => setHide(true)

  return (
    !!renderBanner && (
      <StyledBanner
        showIcon={false}
        color={baseColor}
        p={2}
        mb={2}
        ml={1}
        mr={1}
        aria-label='Flex dates price change Banner'
        borderRadius='xl'
        mx={[2, 2, 2, 2, 0]}
      >
        <StyledFlexLeft width={['80%', '80%', '90%', '80%']}>
          <Notification color={notificationColor} />
          <Flex pl={2}>
            <Text fontSize={1} mt={1} aria-label='Price change text'>
              <Text fontSize={1} mt={1} bold display='inline'>
                Heads Up&nbsp;
              </Text>
              {`The cheapest price for this date just ${diff > 0 ? 'increased' : 'decreased'} by $${Math.abs(
                diff
              )}`}
            </Text>{' '}
          </Flex>
        </StyledFlexLeft>

        <StyledFlexRight aria-label='Close price change banner'>
          {' '}
          <StyledClose onClick={handleClick} />
        </StyledFlexRight>
      </StyledBanner>
    )
  )
}

FlexDatesBanner.propTypes = {
  diff: PropTypes.number,
  isVariant: PropTypes.bool,
  prevFlexDatePrice: PropTypes.number,
  price: PropTypes.number,
}
